export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/ML-38c1d857c89c21c1dcd393300a10ad28.png";